import { Region } from './model';

export function telephoneNumberToRegional(region: Region | null, num: string): string {
  if (!num) { return 'Unknown Caller' }

  if (num.startsWith('-')) {
    // don't do anything with number
    return num;
  }

  if (!region) { return num }

  if (num.indexOf(region.countryCode) > -1 && num.indexOf(region.countryCode) <= 1) {
    // removing +
    if (num.startsWith('+')) {
      num = num.substr(1);
    }

    // if full number with country code is present
    if (num.startsWith(region.countryCode)) {
      // removing country code from a string
      num = num.substring(num.indexOf(region.countryCode) + region.countryCode.length);
      // removing local area code
      if (num.startsWith(region.localAreaCode)) {
        num = num.substring(region.localAreaCode.length);
      } else {
        // check if we need to add (NationalAccessCode
        if (!num.startsWith(region.nationalAccessCode) || num.length === region.localNumberLength) {
          num = region.nationalAccessCode + num;
        }
      }
    }
  }

  return num;
}

export function telephoneNumberToNational(region: Region | null, num: string) {
  if (!num) { return 'Unknown Caller' }

  if (num.startsWith('-')) {
    // don't do anything with number
    return num;
  }

  if (!region) { return num }

  if (num.indexOf(region.countryCode) > -1 && num.indexOf(region.countryCode) <= 1) {
    // removing +
    if (num.startsWith('+')) {
      num = num.substr(1);
    }

    // if full number with country code is present
    if (num.startsWith(region.countryCode)) {
      // removing country code from a string
      num = region.nationalAccessCode + num.substring(region.countryCode.length);
    }
  }

  return num;
}


export function stripHtmlTags(text:string){
  if(!text) return ''
  if(text === '') return ''
  const x =  text.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, '').replace(/\r\n/g, '').replace(/\n\n/g, '').replace(/\n/g, '');
  return x
}
